import React, { useState, useMemo, useEffect, useContext } from 'react';
import { Box, Tab, Tabs, Button } from '@mui/material';
import moment from 'moment';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import TabPanel from '../../components/TabPanel';
// Providers
import { DashboardProvider } from '../Dashboard/useDashboard';
// Context
import useCcoContext from './context/useCcoContext';
// Components
import Filter from './components/Filter';
import TreeDataTable from './components/TreeDataTable';

import CreateClientCallOutModalv2 from './components/CreateClientCallOutModalv2';
import ViewClientCallOutModalv2 from './components/ViewClientCallOutModalv2';
// API
import { getCncAccountListv2, getClienCallOutShow } from '../../api/ccoApi';
import AppConst from '../../components/AppLayout/const';

export default function ClientCallOut() {
  const defaultFilterForm = {
    team: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    group: { label: 'ALL', value: null },
    month_year: moment().format('YYYY-MM'),
  };

  const { onSetTitle } = useContext(AppConst.AppContext);
  onSetTitle('My Client Call Outs');
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  // Create Ccco
  const [createCco, setCreateCco] = useState({
    toggle: false,
    data: {},
  });

  const [filterForm, setFilterForm] = useState(defaultFilterForm);
  const [clearFilterForm, setClearFilterForm] = useState();
  // Cco Data
  const [ccoData, setCcoData] = useState({ loading: false, tableData: [] });
  const [ccoCalendar, setCcoCalendar] = useState({ loading: false, calendarData: [] });
  // View CCO Modal
  const [viewCco, setViewCco] = useState({ toggle: false, row: {} });
  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateCcoList = async (newParams = null) => {
    try {
      setCcoData({ ...ccoData, loading: true });
      let request;
      if (newParams !== null) {
        request = {
          date: moment(newParams?.date).format('YYYY-MM-DD'),
          type: 'list',
        };
      } else {
        request = {
          month: Number(moment(filterForm?.month_year).format('MM')),
          year: Number(moment(filterForm?.month_year).format('YYYY')),
          type: 'list',
        };
      }

      const response = await getCncAccountListv2(request);
      const { code, data, message } = response.data;

      if (code === '200') {
        toast.success(message);
        setCcoData({ ...ccoData, loading: false, tableData: data });
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const resetList = () => {
    handleGenerateCcoList();
  };

  const handleViewCco = async (row) => {
    try {
      toast.loading('Processing request please wait..');
      console.log('handleViewCco', row);
      const response = await getClienCallOutShow(row);
      const { code, data, message } = response.data;

      if (code === '200') {
        setViewCco({ ...viewCco, toggle: true, row: data });
        toast.success(message);
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleGenerateFilter = () => {
    handleGenerateCcoList();
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilterForm);
    setClearFilterForm(moment().format('HHmmss'));
  };
  useEffect(() => {
    handleGenerateFilter();
  }, [clearFilterForm]);

  return (
    <DashboardProvider>
      <useCcoContext.Provider
        value={useMemo(
          () => ({
            // DATA
            loading,
            filterForm,
            defaultFilterForm,
            ccoData,
            ccoCalendar,
            createCco,
            viewCco,
            // STATE
            setLoading,
            setFilterForm,
            setCcoData,
            setCcoCalendar,
            setCreateCco,
            setViewCco,
            // FUNCTION
            handleViewCco,
            handleGenerateCcoList,
            handleGenerateFilter,
            handleClearFilter,
          }),
          [filterForm, ccoData.loading, ccoCalendar.loading, createCco.toggle, viewCco.toggle],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleChangeActiveTab}
                        aria-label='basic tabs example'
                      >
                        <Tab
                          label='Call Outs'
                          id='client-call-outs'
                          aria-controls='client-call-outs'
                        />
                      </Tabs>
                    </Box>
                    <TabPanel value={activeTab} index={activeTab}>
                      {activeTab === 0 ? (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <TreeDataTable />
                          </Grid>
                        </Grid>
                      ) : (
                        ''
                      )}
                    </TabPanel>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
        {createCco?.toggle ? <CreateClientCallOutModalv2 /> : ''}
        {viewCco?.toggle ? <ViewClientCallOutModalv2 /> : ''}
      </useCcoContext.Provider>
    </DashboardProvider>
  );
}
